import React, { useEffect, useState } from 'react';

/**
 * Shows the running app version at the bottom of every page.
 * The version comes from the API at runtime, so one frontend image serves any
 * environment; if it cannot be read the footer is simply not rendered.
 */
function VersionFooter() {
  const [version, setVersion] = useState(null);

  useEffect(() => {
    let active = true;
    fetch('/api/v1/health')
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (active && data && data.version && data.version !== 'unknown') {
          setVersion(data.version);
        }
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  if (!version) {
    return null;
  }

  return (
    <footer className="version-footer" data-testid="version-footer">
      {version}
    </footer>
  );
}

export default VersionFooter;
